<app-portal></app-portal>

<div class="main">

    <div class="body">

        <div>

            <form [formGroup]="form">

                <div class="grid grid--auto-fill">

                    <mat-form-field>
                        <mat-label>Unidade</mat-label>
                        <mat-select formControlName="unidade">
                            <mat-option [value]="1"> Escola Modelo  </mat-option>
                            <mat-option [value]="2"> Suporte Central  </mat-option>
                            <mat-option [value]="3"> Campinas  </mat-option>
                            <mat-option [value]="4"> Nacional  </mat-option>
                            <mat-option [value]="5"> Paulista  </mat-option>
                            <mat-option [value]="6"> Sorocaba  </mat-option>
                            <mat-option [value]="7"> Jundiaí  </mat-option>
                            <mat-option [value]="8"> Supletivo Urgente  </mat-option>
                            <mat-option [value]="9"> Supletivo Urgente Centro  </mat-option>
                            <mat-option [value]="10"> NacionalTec  </mat-option>
                            <mat-option [value]="11"> Supletivo Abc - Santo André  </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Nome do Usuário</mat-label>
                        <input appTitlecase formControlName="nomeUsuario" matInput >
                        <mat-error>Informação necessária</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Data de Inicio</mat-label>
                        <input formControlName="dataInicio" matInput [max]="today" [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker startView="multi-year"></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Data Final</mat-label>
                        <input formControlName="dataFinal" matInput [max]="today" [matDatepicker]="picker1">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1 startView="multi-year"></mat-datepicker>
                    </mat-form-field>

                </div>

            </form>

        </div>

        <div class="div-cards">

            <mat-card class="mat-card azul">
                <div class="div-p">
                    <p class="p-numero">150</p>
                    <p class="p-texto">Total de Comissões</p>
                </div>
                <div class="div-icon">
                    <mat-icon>attach_file</mat-icon>
                </div>
            </mat-card>

            <mat-card class="mat-card verde">
                <div class="div-p">
                    <p class="p-numero">50</p>
                    <p class="p-texto">Dinheiro no Bolso</p>
                </div>
                <div class="div-icon">
                    <mat-icon>check_circle</mat-icon>
                </div>
            </mat-card>

            <mat-card class="mat-card vermelho">
                <div class="div-p">
                    <p class="p-numero">100</p>
                    <p class="p-texto">Abertos e/ou Inadimplentes</p>
                </div>
                <div class="div-icon">
                    <mat-icon>report</mat-icon>
                </div>
            </mat-card>

        </div>

    </div>

</div>

<app-compartilhe></app-compartilhe>